import React, { useState, useEffect, useCallback } from "react";
import {
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import axios from "axios";
import { Link } from "react-router-dom";

export default function AdminPage() {
  const API_URL =  window.__ENV__?.API_URL  || "https://m2oi2mvv2e.execute-api.ap-south-1.amazonaws.com/Prod/api"; // ✅ Uses `.env`

  const [timeSheets, setTimeSheets] = useState([]);
  const [startDate, setStartDate] = useState(dayjs().startOf("month"));
  const [endDate, setEndDate] = useState(dayjs());
  const [loading, setLoading] = useState(false);

  // ✅ Fetch Time Sheets
  const fetchData = useCallback(() => {
    setLoading(true);

    axios
      .get(`${API_URL}/admin/timesheets`, {
        params: {
          startDate: startDate.format("YYYY-MM-DD"),
          endDate: endDate.format("YYYY-MM-DD"),
        },
      })
      .then((response) => {
        setTimeSheets(response.data);
      })
      .catch((error) => {
        console.error("Error fetching timesheets:", error);
        alert("Failed to fetch timesheets. Please try again.");
      })
      .finally(() => setLoading(false));
  }, [startDate, endDate, API_URL]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // ✅ Logout Function
  const handleLogout = () => {
    alert("Have a good day!!");
    // Optionally, you can redirect the user to a login page after logout.
     window.location.href = "/"; 
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Container maxWidth="lg">
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", textAlign: "center", mt: 3, mb: 3 }}
        >
          Admin - Employee Timesheets
        </Typography>

        <Paper sx={{ p: 3, mb: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 2 }}>
            <DatePicker label="Start Date" value={startDate} onChange={setStartDate} />
            <DatePicker label="End Date" value={endDate} onChange={setEndDate} />
            <Button variant="contained" onClick={fetchData} disabled={loading}>
              {loading ? "Loading..." : "Fetch Timesheets"}
            </Button>
          </Box>
        </Paper>

        <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Employee Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Login Time</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Logout Time</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Hours Worked</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Comments</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {timeSheets.length > 0 ? (
                timeSheets.map((sheet, index) => (
                  <TableRow key={index}>
                    <TableCell>{sheet.employee_name || "N/A"}</TableCell>
                    <TableCell>{sheet.date}</TableCell>
                    <TableCell>{sheet.login_time}</TableCell>
                    <TableCell>{sheet.logout_time || "N/A"}</TableCell>
                    <TableCell>{sheet.hours_worked}</TableCell>
                    <TableCell>{sheet.comments}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ mt: 2, textAlign: "center" }}>
          <Button variant="outlined" onClick={fetchData} disabled={loading}>
            {loading ? "Refreshing..." : "Refresh Data"}
          </Button>
        </Box>
       <Box sx={{ mt: 2, textAlign: "center" }}>
          <Button variant="outlined" onClick={fetchData} disabled={loading}>
            {loading ? "Refreshing..." : "Refresh Data"}
          </Button>
        </Box>
        <Box sx={{ mt: 3, textAlign: "center" }}>
       <Link to="/create-payslip" style={{ textDecoration: "none" }}>
       <Button variant="contained" color="primary">
        ➕ Create Payslip
        </Button>
        </Link>
        </Box>

        {/* ✅ Logout Button at the bottom */}
        <Box sx={{ mt: 3, textAlign: "center" }}>
          <Button variant="contained" color="error" onClick={handleLogout}>
            Logout
          </Button>
        </Box>
      </Container>
    </LocalizationProvider>
  );
}
